import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export class Copyright extends Component {
  scrollToTarget(v_target) {
    var target = document.getElementById(v_target);
    window.scrollTo({
      top: target.offsetTop - 125, 
      behavior: 'smooth'
    });
  }

  render() {
    return (
      <>
        <section className="copyright px-3 pt-2 pb-2">
          <Container fluid>
            <Row>
              <Col lg={6} md={12} className="text-center text-lg-start">
                <a href="#/" onClick={() => this.scrollToTarget("home")} className='me-2'>{this.props.lang === 'th' ? "หน้าหลัก" : "Home"}</a>
                <a href="#/" onClick={() => this.scrollToTarget("service")} className='me-2'>{this.props.lang === 'th' ? "บริการของเรา" : "Our Services"}</a>
                <a href="#/" onClick={() => this.scrollToTarget("about")} className='me-2'>{this.props.lang === 'th' ? "เกี่ยวกับเรา" : "About us"}</a>
                <a href="#/" onClick={() => this.scrollToTarget("product")} className='me-2'>{this.props.lang === 'th' ? "สินค้าของเรา" : "Product"}</a>
                <a href="#/" onClick={() => this.scrollToTarget("contact")} className='me-2'>{this.props.lang === 'th' ? "ติดต่อเรา" : "Contact us"}</a>
              </Col>
              <Col lg={6} md={12} className="text-center text-lg-end">Copyright&copy; 2023 by KTN Plaspack Co., Ltd. All Rights Reserved.</Col>
            </Row>
          </Container>
        </section>
      </>
    )
  }
}

export default Copyright